import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { BaseAddComponent } from '../base-add/base-add.component';
import { Slider } from 'src/app/entities/slider';
import { SliderService } from 'src/app/services/slider.service';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-slider-add',
  templateUrl: './slider-add.component.html',
  styleUrls: ['./slider-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SliderAddComponent extends BaseAddComponent<Slider> implements OnInit {

  pathUrlList = 'slider';

  constructor(
    protected sliderService: SliderService,
    protected alertService: AlertService,
    protected filesService: GoogleStorageService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = sliderService;
    this.serviceGoogle = filesService;
    this.item = new Slider();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: '',
        required: true,
      },
      /*{
        type: 'file',
        key: 'url_image',
        fileType: 'path',
        title: 'Seleccionar imagen',
        caption: ''
      },*/
      {
        type: 'file',
        key: 'url_image',
        fileType: 'path',
        title: 'Imagen',
        caption: '',
        required: true,
      },
      {
        type: 'string',
        key: 'alt_image',
        title: 'ALT de la imagen (Opcional)',
        caption: ''
      },
      {
        type: 'string',
        key: 'url_link',
        title: 'URL Enlace',
        caption: ''
      },
      {
        type: 'select',
        key: 'status',
        title: 'Estado',
        caption: '',
        options: [
          {
            title: 'Activado',
            value: 1
          },
          {
            title: 'Desactivado',
            value: 0
          }
        ]
      }
    ];
  }
}
